import React, { useEffect } from "react";
import Header from "../Home/Header";
import Footer from "../Footer/Footer";
import DeliveryDetails from "../Myorders/DeliveryDetails";

const DeliveredDEtails = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  return (
    <>
      <Header />
      <DeliveryDetails />
      <Footer />
    </>
  );
};

export default DeliveredDEtails;
